/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_Tax_IdInputs */

const en_admin_external_booking_edit_tax_id = /** @type {(inputs: Admin_External_Booking_Edit_Tax_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tax ID`)
};

const de_admin_external_booking_edit_tax_id = /** @type {(inputs: Admin_External_Booking_Edit_Tax_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Steuer-ID`)
};

const es_admin_external_booking_edit_tax_id = /** @type {(inputs: Admin_External_Booking_Edit_Tax_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identificador fiscal`)
};

const fr_admin_external_booking_edit_tax_id = /** @type {(inputs: Admin_External_Booking_Edit_Tax_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N° fiscal`)
};

const nl_admin_external_booking_edit_tax_id = /** @type {(inputs: Admin_External_Booking_Edit_Tax_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Btw-nummer`)
};

/** @type {(inputs: Admin_External_Booking_Edit_Tax_IdInputs) => LocalizedString} */
const it_admin_external_booking_edit_tax_id = en_admin_external_booking_edit_tax_id;

/** @type {(inputs: Admin_External_Booking_Edit_Tax_IdInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_tax_id = en_admin_external_booking_edit_tax_id;

/** @type {(inputs: Admin_External_Booking_Edit_Tax_IdInputs) => LocalizedString} */
const pl_admin_external_booking_edit_tax_id = en_admin_external_booking_edit_tax_id;

/** @type {(inputs: Admin_External_Booking_Edit_Tax_IdInputs) => LocalizedString} */
const hu_admin_external_booking_edit_tax_id = en_admin_external_booking_edit_tax_id;

/** @type {(inputs: Admin_External_Booking_Edit_Tax_IdInputs) => LocalizedString} */
const ro_admin_external_booking_edit_tax_id = en_admin_external_booking_edit_tax_id;

/**
* | output |
* | --- |
* | "Tax ID" |
*
* @param {Admin_External_Booking_Edit_Tax_IdInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_tax_id = /** @type {((inputs?: Admin_External_Booking_Edit_Tax_IdInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Tax_IdInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_tax_id(inputs)
	if (locale === "de") return de_admin_external_booking_edit_tax_id(inputs)
	if (locale === "es") return es_admin_external_booking_edit_tax_id(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_tax_id(inputs)
	if (locale === "nl") return nl_admin_external_booking_edit_tax_id(inputs)
	if (locale === "it") return it_admin_external_booking_edit_tax_id(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_tax_id(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_tax_id(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_tax_id(inputs)
	return ro_admin_external_booking_edit_tax_id(inputs)
});
export { admin_external_booking_edit_tax_id as "admin.external_booking_edit.tax_id" }